<template>
  <v-dialog v-model="dialog" max-width="500px" content-class="select-dialog">
    <v-card>
      <v-card-title>
        <span> {{ contentTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-list-item-group color="primary">
          <v-list-item v-for="(item, i) in contentItems" :key="i" @click="selectItemAction(item)">
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn depressed v-if="useBtnCancel" @click="cancel"> 취소 </v-btn> -->
        <v-btn color="primary" x-large depressed block rounded @click="ok">
          확인
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      dialog: false,
      contentOrder: 0,
      contentTitle: "",
      contentItems: [],
      selectedItem: [],
    };
  },
  methods: {
    open(_order, _title, _items) {
      console.log("_order", _order);

      this.contentOrder = _order;
      this.contentTitle = _title;
      this.contentItems = _items;
      this.dialog = true;
    },
    cancel() {
      this.dialog = false;
      this.$emit("clickCancel");
    },
    ok() {
      this.dialog = false;
      this.$emit("clickOk", this.contentOrder, this.selectedItem);
      this.selectedItem = "";
      $('.v-list-item').removeClass('v-list-item--active');
    },
    selectItemAction(item) {
      this.selectedItem = item;
    },
  },
};
</script>

<style lang="scss">
.v-dialog.select-dialog {
  .v-card__title {
    padding: 0 0 10px !important;
    justify-content: start;
    font-size: 18px;
    font-weight: 700;
  }

  .v-card {
    .v-card__text {
      padding: 0 1rem 1rem;
      height: 200px;
      overflow: auto;

      .v-list-item {
        &:not(:last-child) {
          border-bottom: 1px solid #ddd;
          .v-list-item__content {
            padding: 6px 0;
          }
        }
      }
    }

    .v-card__actions {
      padding: 2rem 0 0;
      justify-content: flex-end;
    }
  }
}
</style>